import { Title } from "melco-ui";
import { StatisticsBarChart } from "./StatisticsBarChart";
import { StatisticsConfig } from "../../../../hooks/reporting/statistics/useStatistics";
import { ReportingMelcoModelsGenericList1MelcoMachineStatisticsModelsStatisticListItem } from "melco-shared-logic";
import { useTranslation } from "react-i18next";

type AmountOfStitchesProps = {
  data?: ReportingMelcoModelsGenericList1MelcoMachineStatisticsModelsStatisticListItem;
  dataConfig?: StatisticsConfig;
  isLoading?: boolean;
};

export const AmountOfStitches: React.FC<AmountOfStitchesProps> = ({
  dataConfig,
  data,
  isLoading,
}) => {
  const { t } = useTranslation();

  return (
    <>
      <Title level={5}>
        {t("reporting.statistics.charts.amount_of_stitches")}
      </Title>
      <StatisticsBarChart
        dataConfig={{ ...dataConfig, sortBy: "stitches" }}
        field="stitches"
        data={data}
        isLoading={isLoading}
      />
    </>
  );
};
